import request from '@/plugins/axios'

export function getMileages(limit= 10){
  const query = `SELECT m.*, p.name as create_user_name
  FROM mileage m left join player p on m.create_user_id = p.player_id 
  order by m.create_date desc limit ${limit}`
  return request.post(`/dbManager?getMileages`, {query}).then(({data}) => (data.result))
}
export function insertMileages(content, loginUser){
  const query = `INSERT INTO 
    mileage (content, create_user_id) VALUES ('${content}','${loginUser.player_id}')`
  return request.post(`/dbManager?insertMileages`, {query})
}